import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { Form, Input, message } from "antd";
import commonRules from "@/components/Pages/User/common/rules";
import Dynamic, { DynamicProps, type ExposeDynamicProps } from "@/components/App/Dynamic";
import SafeVerify from "@/components/App/SafeVerify/index";
import { axiosThrottle } from "@/utils/method";
import XtSvg from "components/Xt/Svg";
import { waitRes } from "@/utils/axios";
import AppCountryList from "@/components/App/Country";
import { getOrigin } from "@/utils/method";
import useNextTick from "@/hooks/useNextTick";
import { get_getFaCheckItem, post_updateBindMobile, post_bindMobile } from "@/api/uaapi/user";
import { FaCheckProps } from "@/components/App/SafeVerify";
import Geetest from "@/components/Geetest";
import LocalStorage from "utils/localStorage";
interface MobileProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const { useForm } = Form;
interface MobileDataProps {
  countryCode: string;
  faCheckId: string;
  mobile: string;
  mobileCode: string;
  countryId: string | number;
  newMobileCode: string;
}
const initForm: MobileDataProps = {
  countryCode: "",
  mobile: "",
  faCheckId: "",
  mobileCode: "",
  newMobileCode: "",
  countryId: ''
};
let faResultId = '';
const Mobile: React.FC<MobileProps> = ({ className }) => {
  const t = useTranslation();
  const appCodeDynamicRef = useRef({} as ExposeDynamicProps);
  const geetestRef = React.useRef<any>();
  const { mobile, mobileAuth, getUserInfo } = store.user;
  const router = useRouter();
  const nextTick = useNextTick();
  const { isDark } = store.app;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initForm });
  const [mobileMsgType, setMobileMsgType] = useState(0);
  const [faBizType, setFaBizType] = useState(3);
  const [refType, setRefType] = useState(0);
  const [puzzleValidate, setPuzzleValidate] = useState('');
  const [faCheckData, setFaCheckData] = useState<FaCheckProps>({
    faCheckId: "",
    email: '',
    countryCode: '',
    mobile: '',
    faItems: [],
  });
  useEffect(() => {
    getFaCheckItem();
  }, []);

  const getUserInfoData = async () => await getUserInfo();
  const getFaCheckItem = async () => {
    let type = 3;
    const info = await getUserInfoData();
    if (!!info?.mobile) {
      type = 4;
      setFaBizType(type)
    }
    const { data, err } = await waitRes(get_getFaCheckItem, {
      noHandle401: true,
      errorPop: true,
      params: { faBizType: type }
    });
    if (err) return

    faResultId = data.faCheckId;
    setFaCheckData(data)

    const newFormData = { ...formData };
    newFormData.mobile = '';
    type === 3 ? newFormData.mobileCode = '' : newFormData.newMobileCode = '';
    if (info) {
      newFormData.countryId = info.regCountryId || '';
      newFormData.countryCode = LocalStorage.get('country').code || '';
    }
    console.log(newFormData, info, 'newFormData');
    formIns.setFieldsValue(newFormData);
  };


  /**method */
  const onValuesChange = (changedValues: Partial<MobileDataProps>) => {
    setFormData({ ...formData, ...changedValues });
  };

  const handleGeetestSuccess = async (puzzleValidateString) => {
    setPuzzleValidate(puzzleValidateString);
    appCodeDynamicRef.current.handleClick(true, puzzleValidateString);
  };

  const submitForm = axiosThrottle(async (unlock, res) => {
    try {
      await formIns.validateFields();
      const { data, err } = await waitRes(mobileAuth ? post_updateBindMobile : post_bindMobile, {
        errorPop: true,
        data: { ...formData, faResultId: res.faResultId, },
      });
      unlock();
      if (err) return;
      if (!mobileAuth)
        return message.success(t("2fa.bindMobileSuccess"), () => {
          router.push("/accounts/user/security-center");
        });
      message.success(t("2fa.updateBindMobileSuccess1"), async () => {
        store.user.resetStatusToNotLogin();
        await getUserInfo();
        router.push(`/accounts/login?backUrl=${encodeURIComponent(getOrigin() + "/" + router.locale + "/accounts/user/security-center")}`);
      });
    } catch (error) { }
  });

  return (
    <div className={cx(styles.mobile, className, isDark ? styles["mobile_dark"] : styles["mobile_light"])}>
      {/* 顶栏由 pages/accounts/user 的 backHeader 统一提供 */}
      <div className={styles["content"]}>
        <div className={styles["right_fa"]}>
          {/* 绑定/更改手机 */}
          <div className={styles["right_1"]}>
            <div className={styles["title"]}>{!mobileAuth ? t("google.bindMobile") : t("mobile.change")}</div>
            {mobileAuth && (
              <div className={styles["tan"]}>
                <XtSvg src={require("@/assets/icon-svg/app/tan.svg")} />
                <div className={styles["text_tan"]}>{t("account.safeFund")}</div>
              </div>
            )}
            <div className={styles["tip"]}>
              <Form name="mobileForm" form={formIns} onValuesChange={onValuesChange} layout="vertical">
                <Form.Item className={styles.phoneField} label={!mobileAuth ? t("mobile.mobile") : t("mobile.new")}>
                  <div className={styles.phoneRow}>
                    <div className={styles.phoneCountry}>
                      <AppCountryList
                        selectItem={(obj) => setFormData({ ...formData, countryCode: obj.code || obj.countryCode, countryId: obj.id })}
                        countryQuery="MOBILE"
                        showType="Small"
                      />
                    </div>
                    <Form.Item noStyle name="mobile" rules={commonRules.mobile}>
                      <Input className={styles.phoneInput} placeholder={t("mobile.mobile")} autoComplete="off" />
                    </Form.Item>
                  </div>
                </Form.Item>
                <Form.Item
                  label={!mobileAuth ? t("account.MobileSMSVerificationCode") : t("mobile.newVerify")}
                  name="mobileCode"
                  rules={commonRules.verifyCode}
                >
                  <Input
                    className={styles["common_form_input"]}
                    allowClear
                    autoComplete="off"
                    maxLength={6}
                    suffix={
                      <div>
                        <Dynamic
                          ref={appCodeDynamicRef}
                          isNew={true}
                          mobileNew={formData.mobile}
                          FaValidTypeDict={"MOBILE"}
                          puzzleValidateString={puzzleValidate}
                          msgType={mobileMsgType}
                          faCheckId={faCheckData.faCheckId}
                          codeType={'USER_2004'}
                          disableClick={true}
                          countryCode={formData.countryCode}
                          onClick={() => {
                            setMobileMsgType(0);
                            nextTick(() => {
                              setRefType(1);
                              (geetestRef?.current as any).verify();
                            });
                          }}
                        />
                      </div>
                    }
                  />
                </Form.Item>
              </Form>

              {/* 安全验证 */}
              {faCheckData.faItems.length > 0 && <div className={styles["email_text"]}>{t("app.2fa")}</div>}
              <SafeVerify
                faCheckData={faCheckData}
                showLink={true}
                faBizType={faBizType}
                dynamicCodeType={!mobileAuth ? 'USER_2004' : 'USER_2005'}
                handleSuccessFn={submitForm}
                beforeConfirm={<Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default observer(Mobile);
